<template>
  <div class="chart-box">
    <el-row :gutter="20">
      <el-col :span="6">
        <centerLeft defultIndex="3-1" />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>个人中心</el-breadcrumb-item>
          </el-breadcrumb>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>个人中心</span>
            </div>
            <el-form :rules="rules" ref="ruleForm" :model="centerData" label-width="80px">
              <el-form-item label="英文名称" prop="enName">
                <el-input v-model="centerData.enName"></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="centerData.email"></el-input>
              </el-form-item>
              <el-form-item label="电话号码" prop="telephone">
                <el-input v-model="centerData.telephone"></el-input>
              </el-form-item>
              <el-form-item label="学者简介">
                <el-input v-model="centerData.summary" type="textarea" :rows="3"></el-input>
              </el-form-item>
              <el-form-item label="研究领域">
                <el-input v-model="centerData.fieldName" type="textarea" :rows="3"></el-input>
              </el-form-item>
              <el-form-item label="头像">
                <el-upload
                  class="upload-demo"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-success="handleExceed"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div
                    slot="tip"
                    class="el-upload__tip"
                  >注:仅支持jpg、png格式</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="updateMember">保存</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'claim',
  components: {
    centerLeft,
  },
  data() {
    return {
      activeName: 'second',
      isRouter: true,
      centerData: {
        enName: '',
        email: '',
        telephone: '',
        summary: '',
        fieldName: '',
      },
      rules: {
        enName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
        ],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        telephone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
        ],
      },
      userId: '',
      fileList:[],
      fileObj:[]
    }
  },
  methods: {
    handleExceed(files, fileList) {
      this.fileObj = fileList.raw
    },
    getData(id) {
      let currThis = this
      //个人中心
      axios({
        method: 'get',
        url: '/api/member/memberCentral/' + id,
      })
        .then(function (response) {
          if(response.data.data.irUser.summary) response.data.data.summary = response.data.data.irUser.summary
          currThis.centerData = response.data.data
        })
        .catch(function (thrown) {
        })
    },
    updateMember() {
      let currThis = this
      let obj = this.centerData
      let formData = new FormData()
      obj.id = this.userId
      formData.append('enName',this.centerData.enName)
      formData.append('email',this.centerData.email)
      formData.append('telephone',this.centerData.telephone)
      formData.append('fieldName',this.centerData.fieldName)
      formData.append('summary',this.centerData.summary)
      formData.append('id',this.centerData.id)
      formData.append('fileObj',this.fileObj)
      //个人中心
      this.$axios.post(
        '/api/memberIndex/updateMemberCentral',
        formData
      )
        .then(function (response) {
         if(response.data.status == 200){
           currThis.$message({
             type:'success',
             message:'保存成功'
           })
         }
        })
        .catch(function (thrown) {
        })
    },
  },
  mounted() {
    //this.userId=localStorage.getItem('userId');
    this.userId = this.$cookies.get('rtnVal')
    this.getData(this.userId)
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/center.vue